import { useFormikContext } from 'formik';

import { Modal, ModalProps } from '../../Modal';

export type FormModalProps = ModalProps;


export const FormModal: React.FC<FormModalProps> = ({ children, loading, ...props }) => {
  const formikContext = useFormikContext();

  return (
    <Modal
      loading={formikContext.isSubmitting || loading}
      TransitionProps={{
        onExited: () => {
          formikContext.resetForm();
        }
      }}
      data-testid="form-modal"
      {...props}
    >
      {children}
    </Modal>
  );
};
